import { Navigate, Route, Routes } from "react-router-dom";
import LandingLayout from "../pages/LandingLayout/LandingLayout";
import RegistrationLayout from "../pages/RegistrationLayout/RegistrationLayout";
import Register from "../components/Registration/Register";
import AuthenticationLayout from "../pages/AuthenticationLayout/AuthenticationLayout";
import Login from "../components/Login/Login";
import OtpValidation from "../components/Login/OtpValidation";
import { useAuth } from "../context/AuthProvider";
import { UserService } from "../services/UserService";
import { routePaths } from "../constants/routePaths";
import ClinicManagement from "../components/UserManagement/ClinicManagement";
import SetPassword from "../components/Registration/SetPassword";

const RoutesConfig = () => {
  const auth = useAuth();

  return (
    <Routes>
      {auth?.isLoggedIn === "true" || UserService.isLoggedIn === "true" ? (
        <Route element={<LandingLayout />}>
          <Route
            path={routePaths.clinicManagement}
            element={<ClinicManagement />}
          ></Route>
          <Route path={routePaths.base} element={<ClinicManagement />} />
          <Route
            path={routePaths.wild}
            element={<Navigate to={routePaths.clinicManagement} />}
          />
        </Route>
      ) : (
        <>
          <Route element={<AuthenticationLayout />}>
            <Route path={routePaths.otp} element={<OtpValidation />} />
            <Route path={routePaths.setPassword} element={<SetPassword />} />
            <Route path={routePaths.login} element={<Login />} />
            <Route
              path={routePaths.base}
              element={<Navigate to={routePaths.login} />}
            />
            <Route
              path={routePaths.wild}
              element={<Navigate to={routePaths.login} />}
            />
          </Route>
        </>
      )}
      <Route element={<RegistrationLayout />}>
        <Route path={routePaths.register} element={<Register />} />
      </Route>
    </Routes>
  );
};

export default RoutesConfig;
